import { MenuItem } from '@adaptiva/core/menus';
import { FilterComponentMenuController, FilterSelectionEmitter, IFilterNode } from '@adaptiva/widgets/filter';
import { Injectable } from '@angular/core';

@Injectable()
export class PrerequisiteTreeMenuController extends FilterComponentMenuController {

	public override conditionMenuItems(_node: IFilterNode, _selectionEmitter: FilterSelectionEmitter): MenuItem<IFilterNode>[] {
		return [
			this.getAndMenuItem(_node, _selectionEmitter),
			this.getOrMenuItem(_node, _selectionEmitter),
		];
	}

}
